var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2923 4.98413C15.5599 5.26523 15.549 5.71002 15.2679 5.9776L7.14774 13.7073C7.00907 13.8393 6.82254 13.909 6.63129 13.9003C6.44004 13.8916 6.26062 13.8053 6.13451 13.6612L3.01139 10.0937C2.75576 9.80165 2.78525 9.3577 3.07726 9.10207C3.36926 8.84644 3.81321 8.87593 4.06884 9.16794L6.70939 12.1843L14.2989 4.95966C14.58 4.69208 15.0247 4.70304 15.2923 4.98413Z",
    fill: "#8A3EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.fd23745a1d448a033030172b888954d6.svg";
export { ForwardRef as ReactComponent };